import { Injectable } from '@angular/core';
import { CashaccountResourceService } from './database/resource/cashaccount-resource.service';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class InvoicepaymentService {

  constructor( private cashAccountResource: CashaccountResourceService ) { }


  public async getCashAccounts() {
     return this.cashAccountResource.getCashAccounts();
  }

  public async getPaymentMethods() {
     return this.cashAccountResource.getPaymentMethods();
  }

  public getExpiryDates(): any[] {
    const expiryDate: any = [];

    const datepipe = new DatePipe('en-gb');

    expiryDate.push( datepipe.transform( new Date() , 'MM/yyyy') );

    let count = 0;
    while ( count < 36) {
        count++;
        const dateToAdd = new Date();
        dateToAdd.setMonth( dateToAdd.getMonth() + count);
        expiryDate.push( datepipe.transform( dateToAdd , 'MM/yyyy') );
    }
    return expiryDate;
  }


  public async test() {
    console.log( 'InvoicePaymentService test');
    const cashAccounts = await this.getCashAccounts();
    console.log( cashAccounts );
    const paymentMethods = await this.getPaymentMethods();
    console.log( paymentMethods );
    const expiryDates = await this.getExpiryDates();
    console.log( expiryDates );
  }
}
